import React from 'react';
import './SelectListItemName.less';

export const SelectListItemName = ({text, isDisabled}) => {
	return <span className={`select-list-item-name ${isDisabled ? 'select-list-item-name--disabled' : ''}`}>{text}</span>
}
